import React from "react";

const NotFound = () => {
  return <h1>Coming Soon..!</h1>;
};

export default NotFound;
